import { Timestamp } from '@weblite/ts-action'
import { LocalFind, LocalInsert } from '@weblite/persist'
import { RELEASE_TIME, VERSION } from '$setup/version'

interface ReleaseInfo {
  releaseTime: number
  version: string
}

const KEY = 'appRelease'
export function saveReleaseVersion(releaseTime: Timestamp, version: string) {
  LocalInsert(KEY, { releaseTime, version })
}

export function getCurrentRelease(): ReleaseInfo {
  const localRelease = LocalFind(KEY)
  if (!localRelease) saveReleaseVersion(RELEASE_TIME, VERSION)
  const release = localRelease || LocalFind(KEY)
  release.releaseTime = new Date(release.releaseTime).getTime()
  return release
}
